var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.00344C3.99974 2.53387 3.78877 3.04248 3.41351 3.41736C3.03825 3.79225 2.52943 4.00271 1.999 4.00244C1.46857 4.00218 0.959965 3.79121 0.585079 3.41595C0.210194 3.04069 -0.000264966 2.53187 2.50361e-07 2.00144C0.000265467 1.47101 0.211233 0.962406 0.586494 0.587521C0.961754 0.212636 1.47057 0.00217644 2.001 0.00244166C2.53143 0.00270687 3.04004 0.213675 3.41492 0.588935C3.78981 0.964195 4.00027 1.47301 4 2.00344ZM4.06 5.48344H0.0600002V18.0034H4.06V5.48344ZM10.38 5.48344H6.4V18.0034H10.34V11.4334C10.34 7.77344 15.11 7.43344 15.11 11.4334V18.0034H19.06V10.0734C19.06 3.90344 12 4.13344 10.34 7.16344L10.38 5.48344Z",
    fill: "url(#paint0_linear_87_150)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_150",
    x1: 0.276392,
    y1: 12.8741,
    x2: 4.61522,
    y2: 13.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315771,
    stopColor: "#30BDE3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D82AFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinGradient);
export default __webpack_public_path__ + "static/media/linkdin-gradient.fa3e9ffd4e2c8652fd89ac294f79a184.svg";
export { ForwardRef as ReactComponent };